<template>
  <div
    :id="data.id"
    class="overflow-hidden bg-gray-lighten3 text-slate md:bg-white md:py-14 lg:py-[112px]"
  >
    <div class="container">
      <swiper-container
        ref="swiperEl"
        init="false"
        class="!overflow-visible pb-10 md:!overflow-hidden md:px-16 md:pb-0"
      >
        <div
          v-show="showNav"
          slot="container-start"
          class="nav-prev absolute left-0 top-1/2 z-50 flex w-16 -translate-y-1/2 cursor-pointer items-center justify-center text-slate"
        >
          <UiIcon icon="sliderArrowLeft"></UiIcon>
        </div>

        <div
          v-show="showNav"
          slot="container-start"
          class="nav-next absolute right-0 top-1/2 z-50 flex w-16 -translate-y-1/2 cursor-pointer items-center justify-center text-slate"
        >
          <UiIcon icon="sliderArrowRight"></UiIcon>
        </div>

        <swiper-slide
          v-for="(review, i) in (data && data.items) || []"
          :key="i"
          class="rounded-lg p-6 md:p-0 md:px-16 lg:flex lg:items-center lg:justify-between"
          :class="{ 'bg-white': !isDesktop }"
        >
          <div
            v-if="review.image"
            class="mb-[30px] h-[80px] w-[80px] flex-shrink-0 overflow-hidden md:mr-[9.6%] md:flex md:h-auto md:w-[39.7%] md:items-center lg:mb-0 xl:mr-[129px] xl:w-[438px]"
          >
            <CdnImg
              :src="handleImageSrc(review.image)"
              :alt="handleImageAlt(review.image)"
              class="w-full rounded-md"
              :width="438"
              :height="438"
              loading="lazy"
            />
          </div>

          <div>
            <UiIcon icon="quote" class="mb-[30px]"></UiIcon>

            <div
              v-if="review.title"
              class="title mb-4 bg-gradient-to-b from-[#432A9E] to-[#2050A7] bg-clip-text text-lg uppercase leading-none text-transparent md:text-3xl"
              v-html="review.title"
            />

            <div
              v-if="review.text"
              class="mb-6 text-sm font-bold leading-[1.225rem] text-slate md:text-md md:leading-[1.8rem]"
              v-html="review.text"
            />

            <div
              v-if="review.name"
              class="text-sm font-bold leading-[1.225rem] text-slate"
              v-html="review.name"
            />

            <div
              v-if="review.position"
              class="text-sm leading-[1.225rem] text-slate"
              v-html="review.position"
            />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint, useSwiperElement } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: { id?: string; items: any };
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({ items: [] }),
});

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('lg');

const swiperOptions = {
  navigation: {
    prevEl: '.nav-prev',
    nextEl: '.nav-next',
  },
  loop: true,
  slidesPerView: 1,
  spaceBetween: 16,
  observer: true,
};

const swiperEl = useSwiperElement(swiperOptions);

const showNav = computed(
  () => isDesktop.value && props.data?.items?.length > 1,
);
</script>
